import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { getAll, graphQL } from '../../../api';
import { search as createSearch } from '@/_store/utils/app/search';
import { stringyObject } from '@/_store/utils/helpers';
import { createPaginatedRequest } from '@/_store/utils/app/paginatedRequestBuilder';
import {
  sessionCallString,
  sharkScreensCallString,
} from '@/_store/modules/reports/requestConfig';

const moment = extendMoment(Moment);
// actions
const actions = {
  acquireGroups: async (
    {
      dispatch, commit, rootState, rootGetters
    },
    payload
  ) => new Promise((resolve, reject) => {
    if (rootGetters['account/getCurrentClient'].client_name === 'shark') {
      dispatch('acquireSharkGroups', payload);
    } else {
      commit('setGroupsTableLoading', true);
      let variables = {};
      const search = createSearch();
      const filters = rootState.filters.filter;

      const user_groups =
          rootGetters['account/getCurrentUser'].group_id &&
          rootGetters['account/getCurrentUser'].group_id[0];
      if (user_groups && user_groups !== 'all') {
        variables = { uuid: user_groups };
      } else {
        if (filters.city !== undefined && filters.city !== '') {
          variables = { uuid: filters.city };
        }
        if (filters.groupName !== undefined && filters.groupName !== '') {
          variables = { uuid: filters.groupName };
        }
      }

      let sdate = moment('1.1.1970').format('X');
      let edate = moment().format('X');
      if (filters.area !== undefined && filters.area !== '') {
        variables.area_id = filters.area;
      }
      if (
        filters.start_date !== '' &&
          filters.start_date !== undefined &&
          filters.end_date !== '' &&
          filters.end_date !== undefined
      ) {
        sdate = moment(filters.start_date).format('X');
        edate = moment(filters.end_date).format('X');
      }

      let indexType = 'all-index';
      if (variables.uuid) {
        indexType = '';
      } else if (variables.area_id) {
        indexType = 'area-index';
      }
      variables = stringyObject(variables);
      const clientTable = rootGetters['account/getCurrentClient'].table_name;

      const callString = `{
          group_name,
          last_activity,
          city,
          area_id,
          launch_mode,
          contact {
            contact_name,
            phone,
            email
          },
          address{
            city,
            state
          },
          error,
          uuid,
          success
        }`;

      let query = `{get(type_name: "group", 
          sdate: ${sdate},
          edate: ${edate},            
          search: ${search},
          filters: {},
          group: ${variables}, 
          table_name:"${clientTable}", 
          index: "${indexType}",`;

      query = query.concat(`)${callString}}`);

      getAll(`/group?query=${encodeURIComponent(query)}`)
        .then(res => {
          dispatch('acquireGroupScreens', {
            groupData: res.data.data.get,
            sessionData: payload.rounds,
          });
          commit('setGroupsTableLoading', false);
          // commit("setGroups", res.data.data.get)
          resolve(res);
        })
        .catch(err => {
          commit('setGroupsTableLoading', false);
          reject(err);
        });
    }
  }),
  acquireSharkGroups: async ({ commit, rootState, rootGetters }, payload) => new Promise((resolve, reject) => {
    commit('setGroupsTableLoading', true);
    let variables = {};
    const filters = rootState.filters.filter;
    const search = filters.search ? filters.search : '';

    const user_groups =
        rootGetters['account/getCurrentUser'].group_id &&
        rootGetters['account/getCurrentUser'].group_id[0];
    if (user_groups && user_groups !== 'all') {
      variables = { uuid: user_groups };
    } else {
      if (filters.city !== undefined && filters.city !== '') {
        variables = { uuid: filters.city };
      }
      if (filters.groupName !== undefined && filters.groupName !== '') {
        variables = { uuid: filters.groupName };
      }
    }

    if (filters.area !== undefined && filters.area !== '') {
      variables.area_id = filters.area;
    }

    variables = stringyObject(variables);

    const callString = `{
        group_name,
        last_activity,
        city,
        launch_mode,
        contact_name,
        total_screens
        phone,
        email,
        city,
        state,
        error,
        total,
        uuid,
        success
      }`;

    const orderBy = payload.sortBy ? payload.sortBy : 'last_activity';
    const sortDir =
        payload.sortDesc && payload.sortDesc[0] === false ? 'ASC' : 'DESC';

    graphQL({
      query: `
          query {
            getAllGroups(
              itemsPerPage: ${payload.itemsPerPage}
              page: ${payload.page}
              sortBy: "${orderBy}"
              sortDir: "${sortDir}"
              search: "${search}"
              filter: ${variables}
            ) ${callString}
          }
        `,
    })
      .then(res => {
        commit('setSharkGroupsData', {
          groups: res.data.data.getAllGroups,
          rounds: payload.rounds || [],
          filter: rootState.filters.filter,
        });
        commit('setGroupsTableLoading', false);
        resolve(res);
      })
      .catch(err => {
        commit('setGroupsTableLoading', false);
        reject(err);
      });
  }),
  acquireGroupScreens: async ({ commit, rootGetters, rootState }, payload) => new Promise((resolve, reject) => {
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/screen?query=${encodeURIComponent(
        `{get(type_name: "screen", 
            table_name:"${clientTable}", 
            index: "all-index"
          ){
            uuid,
            group_id
          }}`
      )}`
    )
      .then(res => {
        payload.groupData.map(group => {
          group.screens = [];
          res.data.data.get.map(screen => {
            if (group.uuid === screen.group_id) {
              group.screens.push(screen);
            }
          });
        });
        if (rootGetters['account/getCurrentClient'].client_name === 'shark') {
          payload.groupData.sort((a, b) => (a.last_activity < b.last_activity ? 1 : -1));
          commit('setSharkGroupsData', {
            groups: payload.groupData,
            rounds: payload.sessionData || [],
            filter: rootState.filters.filter,
          });
        }
        commit('setGroups', payload.groupData);
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  acquireSessions: async (
    {
      dispatch, rootGetters, commit, getters
    },
    payload
  ) => new Promise((resolve, reject) => {
    commit('setScreensTableLoading', true);
    commit('setGroupsTableLoading', true);
    const reportsFilter = rootGetters['filters/getFilter'];
    const user_groups =
        rootGetters['account/getCurrentUser'].group_id &&
        rootGetters['account/getCurrentUser'].group_id[0];
    const filterVariables = {};
    let variables = {};
    let sdate = moment()
      .day(0)
      .format('X');
    let edate = moment()
      .day(6)
      .format('X');

    if (user_groups && user_groups !== 'all') {
      variables.group_id = user_groups;
    } else if (
      reportsFilter.group_id !== undefined &&
        reportsFilter.group_id !== ''
    ) {
      variables.group_id = reportsFilter.group_id;
    }

    if (reportsFilter.area !== undefined && reportsFilter.area !== '') {
      variables.area_id = reportsFilter.area;
    }
    if (reportsFilter.city !== undefined && reportsFilter.city !== '') {
      filterVariables.city = reportsFilter.city;
    }
    if (
      reportsFilter.start_date !== '' &&
        reportsFilter.start_date !== undefined &&
        reportsFilter.end_date !== '' &&
        reportsFilter.end_date !== undefined
    ) {
      sdate = moment
        .utc(reportsFilter.start_date)
        .local()
        .format('X');
      edate = moment
        .utc(reportsFilter.end_date)
        .local()
        .format('X');
    }
    variables = JSON.stringify(variables).replace(/"([^"]+)":/g, '$1: ');
    const filterParams = {
      variables,
      filterVariables,
      sdate,
      edate,
    };
    if (rootGetters['account/getCurrentClient'].client_name === 'shark') {
      commit('setRoundsTableLoading', true);
      dispatch('getRoundsPlayedChart', {
        filterParams,
        name: rootGetters['account/getCurrentClient'].client_name,
      });
      dispatch('getLaunchModeChart', {
        filterParams,
        name: rootGetters['account/getCurrentClient'].client_name,
      });
      dispatch('getDynamicYardageChart', {
        filterParams,
        name: rootGetters['account/getCurrentClient'].client_name,
      });
      dispatch('getScorecardChart', {
        filterParams,
        name: rootGetters['account/getCurrentClient'].client_name,
      });
      dispatch('getFoodAndBeverageChart', {
        filterParams,
        name: rootGetters['account/getCurrentClient'].client_name,
      });
      dispatch('getListenChart', {
        filterParams,
        name: rootGetters['account/getCurrentClient'].client_name,
      });
      dispatch('getWatchChart', {
        filterParams,
        name: rootGetters['account/getCurrentClient'].client_name,
      });
      dispatch('getTotalCarsChart', {
        filterParams,
        name: rootGetters['account/getCurrentClient'].client_name,
      });
      dispatch('getCarsByModelChart', {
        filterParams,
        name: rootGetters['account/getCurrentClient'].client_name,
      });
      dispatch('getTotalGroupsChart', {
        filterParams,
        name: rootGetters['account/getCurrentClient'].client_name,
      });
      dispatch('getGroupsByModelChart', {
        filterParams,
        name: rootGetters['account/getCurrentClient'].client_name,
      });

      let page;
      if (payload.paginate) {
        page = getters.getLastEvalKey + 1;
        commit('setLastEvalKey', page);
      } else {
        page = getters.getLastEvalKey;
      }

      const orderBy = payload.sortBy ? payload.sortBy : 'start_time';
      const sortDir =
          payload.sortDesc && payload.sortDesc[0] === false ? 'ASC' : 'DESC';

      graphQL({
        query: `
          query {
            getAllRounds(
              itemsPerPage: ${payload.itemsPerPage}
              page: ${payload.page}
              sortBy: "${orderBy}"
              sortDir: "${sortDir}"
              edate: ${edate}
              sdate: ${sdate}
              filter: ${variables}
            ) {
              uuid
              guid
              screen_id
              group_id
              gpsi_car_number
              gpsi_car_id
              mdn
              imei
              elapsed_time
              holes_completed
              nine_hole_factor
              course_launch_intent_mode
              gpsi_server
              gpsi_course_site_id
              consumer_purchases
              billable
              end_time
              start_time
              group_name
              total
              total
              city
              error
              success
            }
          }
        `,
      })
        .then(res => {
          dispatch('acquireSessionScreens', {
            filterParams,
            itemsPerPage: payload.itemsPerPage,
            page: payload.page,
            sortBy: payload.sortBy,
            sortDesc: payload.sortDesc,
            rounds: res.data.data.getAllRounds,
          });
          dispatch('acquireGroups', {
            itemsPerPage: payload.itemsPerPage,
            sortBy: payload.sortBy,
            sortDesc: payload.sortDesc,
            page: payload.page,
            rounds: res.data.data.getAllRounds,
          });
          commit('setRounds', res.data.data.getAllRounds);
          commit('setRoundsTableLoading', false);
          resolve(res);
        })

        .catch(err => {
          commit('setRoundsTableLoading', false);
          reject(err);
        });
    } else {
      createPaginatedRequest(
        filterParams,
        sessionCallString,
        'session',
        payload.paginate
      )
        .then(res => {
          commit(
            'setLastEvalKey',
            res.data.data.getPaginated.attr.LastEvaluatedKey
          );
          dispatch('acquireSessionScreens', {
            rounds: res.data.data.getPaginated.items,
          });
          dispatch('acquireGroups', {
            rounds: res.data.data.getPaginated.items,
          });
          resolve(res);
        })

        .catch(err => {
          reject(err);
        });
    }
  }),
  acquireSessionScreens: async (
    {
      commit, rootState, dispatch, rootGetters, getters
    },
    payload
  ) => new Promise((resolve, reject) => {
    commit('setScreensTableLoading', true);
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    const filters = rootState.filters.filter;
    let filterVariables = {};
    if (filters.color !== undefined && filters.color !== '') {
      filterVariables.status = filters.color.toLowerCase();
    }
    if (filters.status !== undefined && filters.status !== '') {
      filterVariables.session_status = filters.status.toLowerCase();
    }
    if (filters.adSchedule !== undefined && filters.adSchedule !== '') {
      filterVariables.ad_schedule = filters.adSchedule;
    }
    filterVariables = JSON.stringify(filterVariables).replace(
      /"([^"]+)":/g,
      '$1: '
    );

    if (rootGetters['account/getCurrentClient'].client_name === 'shark') {
      let page;
      if (payload.paginate) {
        page = getters.getLastEvalKey + 1;
        commit('setLastEvalKey', page);
      } else {
        page = getters.getLastEvalKey;
      }
      const orderBy =
          payload.sortBy && payload.sortBy.length
            ? payload.sortBy
            : 'last_activity';
      const sortDir =
          payload.sortDesc &&
          payload.sortDesc.length &&
          payload.sortDesc[0] === false
            ? 'ASC'
            : 'DESC';

      graphQL({
        query: `query {
            getAllScreens(
              itemsPerPage: ${payload.itemsPerPage}
              page: ${payload.page}
              sortBy: "${orderBy}"
                sortDir: "${sortDir}"
              search: ""
              filter: ${payload.filterParams.variables}
            ) ${sharkScreensCallString}
          }`,
      })
        .then(res => {
          const screens = res.data.data.getAllScreens.slice(
            0,
            res.data.data.getAllScreens.length
          );
          const allCars = [];
          let { rounds } = payload;
          screens.map(car => {
            car.round_end = 0;
            car.rounds = [];
            if (rounds) {
              rounds.map(round => {
                if (
                  car.uuid === round.screen_id &&
                    car.round_end < round.end_time
                ) {
                  car.round_end = round.end_time;
                  car.gpsi_car_id = round.gpsi_car_id;
                  car.gpsi_car_number = round.gpsi_car_number;
                  car.mdn = round.mdn;
                  car.guid = round.guid;
                  car.imei = round.imei;
                  car.data_usage = round.data_usage;
                  car.gpsi_course_site_id = round.gpsi_course_site_id;
                  car.rounds.push(round);
                }
              });
            }
            if (car.last_activity) {
              allCars.push(car);
            }
          });
          allCars.sort((a, b) => b.last_activity.localeCompare(a.last_activity));
          commit('setScreens', allCars);
          for (let i = 0; i < rounds.length; i++) {
            rounds[i].screen = screens.find(
              screen => screen.uuid === rounds[i].screen_id
            );
          }
          for (let i = 0; i < rounds.length; i++) {
            if (!rounds[i].screen) {
              delete rounds[i];
            }
          }
          rounds = rounds.filter(val => val);
          const allGroups = rootState.account.currentClient.groups;
          const groups = [];
          for (let i = 0; i < rounds.length; i++) {
            rounds[i].group = allGroups.find(
              group => group.uuid === rounds[i].group_id
            );
          }
          for (let i = 0; i < allGroups.length; i++) {
            groups.push({
              text: allGroups[i].group_name,
              value: allGroups[i].uuid,
            });
          }
          const cities = rootState.filters.filterOptions.reports.city;
          const adSchedules =
              rootState.filters.filterOptions.reports.ad_schedule;
          for (let i = 0; i < rounds.length; i++) {
            if (
              rounds[i].group &&
                rounds[i].group.address &&
                !cities.includes(rounds[i].group.address.city)
            ) {
              cities.push(rounds[i].group.address.city);
            }
            if (
              rounds[i].screen &&
                !adSchedules.includes(rounds[i].screen.ad_schedule) &&
                rounds[i].screen.ad_schedule !== null
            ) {
              adSchedules.push(rounds[i].screen.ad_schedule);
            }
          }
          const clientId = rootGetters['account/getCurrentClient'].uuid;
          let tripTypeOptions = [];
          switch (clientId) {
            case '4617860c-4690-4a27-835a-1d9d1bfa4624':
              tripTypeOptions = ['QR Code', 'Digital Key'];
              break;
            case '4aa0754b-6e96-4092-bc61-da873d487628':
              tripTypeOptions = [
                'Bluetooth',
                'Select',
                'Select+',
                'Select++',
                'Prime',
              ];
              break;
            case '66993187-282c-4932-a7c0-153eb0b253a2':
              tripTypeOptions = ['Round Trip', 'One Way'];
              break;
            default:
              tripTypeOptions = ['Round Trip', 'One Way'];
              break;
          }
          commit(
            'filters/setReportsFilterOptions',
            {
              group: groups,
              ad_schedule: adSchedules,
              city: cities,
              status: ['Checked Out', 'Checked In'],
              tripType: tripTypeOptions,
              overdue: ['Overdue', 'Current'],
              color: ['Red', 'Yellow', 'Green'],
            },
            { root: true }
          );
          dispatch('formatReportData', rounds);
          commit('setUtilizationChart', {
            data: rounds,
            screenCount: screens.length,
            filter: rootState.filters.filter,
          });
          if (
            rootGetters['account/getCurrentClient'].client_name === 'shark'
          ) {
            commit('setSharkScreensData', {
              data: res.data.data.getAllScreens,
              filter: rootState.filters.filter,
              client: rounds.name,
            });
          }
          resolve(res);
          commit('setScreensTableLoading', false);
        })
        .catch(error => {
          reject(error);
          commit('setScreensTableLoading', false);
        });
    } else {
      getAll(
        `/screen?query=${encodeURIComponent(
          `{get(type_name: "screen", 
              screen: {}, 
              filters: ${filterVariables}, 
              table_name:"${clientTable}", 
              index: "all-index"
            ){
              uuid, 
              last_activity,
              phone_number,
              session_status,
              group_id,
              launch_mode,
            }}`
          // ad_schedule, //These were taken out because they were causing CORS. Some of them can probably be added back if needed
          //   beep,
          //   charged_off,
          //   area_id,
          //   store_id,
          //   debug,
          //   device_id,
          //   notify_users,
          //   screen_uptime,
          //   status,
          //   version,
          //   trip_type,
          //   session_type,
          //   checked,
          //   pushy_token,
          //   twilio,
          //   error,
          //   success
        )}`
      )
        .then(res => {
          const screens = res.data.data.get;
          const allCars = [];
          commit('setScreens', screens);
          for (let i = 0; i < payload.length; i++) {
            payload[i].screen = screens.find(
              screen => screen.uuid === payload[i].screen_id
            );
          }
          for (let i = 0; i < payload.length; i++) {
            if (!payload[i].screen) {
              delete payload[i];
            }
          }
          payload = payload.filter(val => val);
          const allGroups = rootState.account.currentClient.groups;
          const groups = [];
          for (let i = 0; i < payload.length; i++) {
            payload[i].group = allGroups.find(
              group => group.uuid === payload[i].group_id
            );
          }
          for (let i = 0; i < allGroups.length; i++) {
            groups.push({
              text: allGroups[i].group_name,
              value: allGroups[i].uuid,
            });
          }
          const cities = rootState.filters.filterOptions.reports.city;
          const adSchedules =
              rootState.filters.filterOptions.reports.ad_schedule;
          for (let i = 0; i < payload.length; i++) {
            if (
              payload[i].group &&
                payload[i].group.address &&
                !cities.includes(payload[i].group.address.city)
            ) {
              cities.push(payload[i].group.address.city);
            }
            if (
              payload[i].screen &&
                !adSchedules.includes(payload[i].screen.ad_schedule) &&
                payload[i].screen.ad_schedule !== null
            ) {
              adSchedules.push(payload[i].screen.ad_schedule);
            }
          }
          const clientId = rootGetters['account/getCurrentClient'].uuid;
          let tripTypeOptions = [];
          switch (clientId) {
            case '4617860c-4690-4a27-835a-1d9d1bfa4624':
              tripTypeOptions = ['QR Code', 'Digital Key'];
              break;
            case '4aa0754b-6e96-4092-bc61-da873d487628':
              tripTypeOptions = [
                'Bluetooth',
                'Select',
                'Select+',
                'Select++',
                'Prime',
              ];
              break;
            case '66993187-282c-4932-a7c0-153eb0b253a2':
              tripTypeOptions = ['Round Trip', 'One Way'];
              break;
            default:
              tripTypeOptions = ['Round Trip', 'One Way'];
              break;
          }
          commit(
            'filters/setReportsFilterOptions',
            {
              group: groups,
              ad_schedule: adSchedules,
              city: cities,
              status: ['Checked Out', 'Checked In'],
              tripType: tripTypeOptions,
              overdue: ['Overdue', 'Current'],
              color: ['Red', 'Yellow', 'Green'],
            },
            { root: true }
          );
          dispatch('formatReportData', payload);
          commit('setUtilizationChart', {
            data: payload,
            screenCount: screens.length,
            filter: rootState.filters.filter,
          });
          if (
            rootGetters['account/getCurrentClient'].client_name === 'shark'
          ) {
            commit('setSharkScreensData', {
              data: allCars,
              filter: rootState.filters.filter,
              client: payload.name,
            });
          }
          resolve(res);
          commit('setScreensTableLoading', false);
        })
        .catch(error => {
          reject(error);
          commit('setScreensTableLoading', false);
        });
    }
  }),
  formatReportData: ({ commit }, payload) => {
    let checkedOutCount = 0;
    // let screenCount = 0;
    let overdueCount = 0;
    const sessions = [];
    const chargedOffSessions = [];
    for (let i = 0; i < payload.length; i++) {
      sessions.push(payload[i]);
      if (payload[i].screen && payload[i].screen.charged_off) {
        chargedOffSessions.push(payload[i]);
      }
      if (
        payload[i].screen &&
        payload[i].screen.session_status === 'checked out'
      ) {
        checkedOutCount++;
      }
      if (payload[i].screen && payload[i].screen.session_status === 'overdue') {
        overdueCount++;
      }
    }
    // screenCount++;
    let oneWayCount = 0;
    let roundTripCount = 0;
    const rentalsByWeek = [0, 0, 0, 0, 0, 0, 0];
    const rentalsByDay = [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
    ];
    sessions.map(session => {
      if (
        (session.trip_type &&
          session.trip_type.toUpperCase().replace(' ', '_') === 'ONE_WAY') ||
        (session.trip_type &&
          session.trip_type.toUpperCase().replace(' ', '_') === 'QR_CODE') ||
        (session.trip_type &&
          session.trip_type.toUpperCase().replace(' ', '_') === 'BLUETOOTH')
      ) {
        oneWayCount++;
      } else if (
        (session.trip_type &&
          session.trip_type.toUpperCase().replace(' ', '_') === 'ROUND_TRIP') ||
        (session.trip_type &&
          session.trip_type.toUpperCase().replace(' ', '_') ===
            'DIGITAL_KEY') ||
        (session.trip_type &&
          session.trip_type.toUpperCase().replace(' ', '_') === 'PREMIUM')
      ) {
        roundTripCount++;
      }
      rentalsByWeek[moment(session.start_at * 1000).format('d')]++;
      rentalsByDay[moment(session.start_at * 1000).format('H')]++;
    });
    let chargedOffOneWayCount = 0;
    let chargedOffRoundTripCount = 0;
    chargedOffSessions.map(session => {
      if (
        (session.trip_type &&
          session.trip_type.toUpperCase().replace(' ', '_') === 'ONE_WAY') ||
        (session.trip_type &&
          session.trip_type.toUpperCase().replace(' ', '_') === 'QR_CODE') ||
        (session.trip_type &&
          session.trip_type.toUpperCase().replace(' ', '_') === 'BLUETOOTH')
      ) {
        chargedOffOneWayCount++;
      } else if (
        (session.trip_type &&
          session.trip_type.toUpperCase().replace(' ', '_') === 'ROUND_TRIP') ||
        (session.trip_type &&
          session.trip_type.toUpperCase().replace(' ', '_') ===
            'DIGITAL_KEY') ||
        (session.trip_type &&
          session.trip_type.toUpperCase().replace(' ', '_') === 'PREMIUM')
      ) {
        chargedOffRoundTripCount++;
      }
    });
    commit('setRentalTypeChart', [
      oneWayCount > 0 ? oneWayCount : 0,
      roundTripCount > 0 ? roundTripCount : 0,
    ]);
    commit('setChargedOffRentalTypeChart', [
      chargedOffOneWayCount,
      chargedOffRoundTripCount,
    ]);
    commit('setRentalsByWeek', rentalsByWeek);
    commit('setRentalsByDay', rentalsByDay);
    commit('setSessions', sessions);
    commit('setChargedOffSessions', chargedOffSessions);
    commit('setCheckedInChart', {
      chartData: [payload.length - checkedOutCount, checkedOutCount],
      overdue: overdueCount,
    });
  },
  exportRentalReport: async (
    {
      commit, state, rootGetters, rootState
    },
    payload
  ) => new Promise((resolve, reject) => {
    const attributes = state.exportData.rentals.fields;
    let cols = [];
    if (attributes[0].selected) {
      cols.push({ id: 'screen_id', title: 'Screen' });
    }
    if (
      attributes[1].selected &&
        rootGetters['account/getCurrentClient'].client_name !== 'shark'
    ) {
      cols.push({ id: 'ra_number', title: 'Rental Agreement #' });
    }
    // if (attributes[2].selected) {
    //   cols.push({ id: "city", title: "Originating Location" })
    // }
    // if (attributes[3].selected) {
    //   cols.push({ id: "", title: "Destination Location" })
    // }
    if (attributes[2].selected) {
      cols.push({ id: 'trip_type', title: 'Rental Type' });
    }
    if (attributes[3].selected) {
      cols.push({ id: 'start_at', title: 'Rental Start Date' });
    }
    if (attributes[4].selected) {
      cols.push({ id: 'end_at', title: 'Rental End Date' });
    }
    // if (attributes[7].selected) {
    //   cols.push({ id: "", title: "Length of days" })
    // }
    // if (attributes[8].selected) {
    //   cols.push({ id: "", title: "Rental Revenue" })
    // }

    let filterVariables = {
      type_name: 'session',
    };
    let sdate = moment('1.1.1970').format('X');
    let edate = moment().format('X');
    const filters = rootState.filters.filter;
    if (filters.city !== undefined && filters.city !== '') {
      filterVariables.group_id = filters.city;
    }
    if (filters.area !== undefined && filters.area !== '') {
      filterVariables.area_id = filters.area;
    }
    if (filters.groupName !== undefined && filters.groupName !== '') {
      filterVariables.group_id = filters.groupName;
    }
    if (filters.tripType !== undefined && filters.tripType !== '') {
      filterVariables.trip_type = filters.tripType.toLowerCase();
    }
    // if (filters.overdue === "Overdue") {
    //   filterVariables.due_date = {
    //     lt: moment().format("X")
    //   };
    //   filterVariables.session_status = "Checked-Out";
    // }
    // if (filters.overdue === "Current") {
    //   filterVariables.due_date = {
    //     ge: moment().format("X")
    //   };
    //   variables.screen_filter.session_status = "Checked-Out";
    // }
    if (
      filters.start_date !== '' &&
        filters.start_date !== undefined &&
        filters.end_date !== '' &&
        filters.end_date !== undefined
    ) {
      sdate = moment(filters.start_date).format('X');
      edate = moment(filters.end_date).format('X');
    }
    // if (
    //   filters.search !== "" &&
    //   filters.search !== null &&
    //   filters.searchType !== undefined
    // ) {
    //   variables[`${filters.searchType.toLowerCase().replace(" ", "_")}`] = {
    //     contains: filters.search.toLowerCase()
    //   };
    // }
    filterVariables = JSON.stringify(filterVariables).replace(
      /"([^"]+)":/g,
      '$1: '
    );
    cols = JSON.stringify(cols).replace(/"([^"]+)":/g, '$1: ');
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/session?query=${encodeURIComponent(
        `{export(
            sdate: ${sdate},
            edate: ${edate},
            csv: ${payload.csv}, 
            excel: ${payload.excel}, 
            filters: ${filterVariables}, 
            cols: ${cols}, 
            type_name: "session", 
            table_name:"${clientTable}", 
            index: "all-index"
          ){
            csv,
            excel,
            success
          }}`
      )}`
    )
      .then(res => {
        commit('setExportURL', {
          csv: res.data.data.export.csv,
          excel: res.data.data.export.excel,
          loaded: true,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  exportChargedOffReport: async (
    {
      commit, state, rootGetters, rootState
    },
    payload
  ) => new Promise((resolve, reject) => {
    const attributes = state.exportData.chargedOff.fields;
    let cols = [];
    if (attributes[0].selected) {
      cols.push({ id: 'screen_id', title: 'Screen' });
    }
    if (
      attributes[1].selected &&
        rootGetters['account/getCurrentClient'].client_name !== 'shark'
    ) {
      cols.push({ id: 'ra_number', title: 'Rental Agreement #' });
    }
    // if (attributes[2].selected) {
    //   cols.push({ id: "city", title: "Originating Location" });
    // }
    // if (attributes[3].selected) {
    //   cols.push({ id: "", title: "Destination Location" })
    // }
    // if (attributes[4].selected) {
    //   cols.push({ id: "", title: "Charged Off Date" })
    // }
    if (attributes[2].selected) {
      cols.push({ id: 'start_at', title: 'Rental Start Date' });
    }
    if (attributes[3].selected) {
      cols.push({ id: 'end_at', title: 'Rental End Date' });
    }
    if (attributes[4].selected) {
      cols.push({ id: 'trip_type', title: 'Rental Type' });
    }
    // if (attributes[8].selected) {
    //   cols.push({ id: "", title: "Group Contact(s)" })
    // }
    // if (attributes[9].selected) {
    //   cols.push({ id: "", title: "Call Status" })
    // }
    // if (attributes[10].selected) {
    //   cols.push({ id: "", title: "Notes" })
    // }

    let filterVariables = {
      type_name: 'session',
    };
    let sdate = moment('1.1.1970').format('X');
    let edate = moment().format('X');
    const filters = rootState.filters.filter;
    if (filters.city !== undefined && filters.city !== '') {
      filterVariables.group_id = filters.city;
    }
    if (filters.area !== undefined && filters.area !== '') {
      filterVariables.area_id = filters.area;
    }
    if (filters.groupName !== undefined && filters.groupName !== '') {
      filterVariables.group_id = filters.groupName;
    }
    if (filters.tripType !== undefined && filters.tripType !== '') {
      filterVariables.trip_type = filters.tripType.toLowerCase();
    }
    // if (filters.overdue === "Overdue") {
    //   filterVariables.due_date = {
    //     lt: moment().format("X")
    //   };
    //   filterVariables.session_status = "Checked-Out";
    // }
    // if (filters.overdue === "Current") {
    //   filterVariables.due_date = {
    //     ge: moment().format("X")
    //   };
    //   variables.screen_filter.session_status = "Checked-Out";
    // }
    if (
      filters.start_date !== '' &&
        filters.start_date !== undefined &&
        filters.end_date !== '' &&
        filters.end_date !== undefined
    ) {
      sdate = moment(filters.start_date).format('X');
      edate = moment(filters.end_date).format('X');
    }
    // if (
    //   filters.search !== "" &&
    //   filters.search !== null &&
    //   filters.searchType !== undefined
    // ) {
    //   variables[`${filters.searchType.toLowerCase().replace(" ", "_")}`] = {
    //     contains: filters.search.toLowerCase()
    //   };
    // }
    filterVariables = JSON.stringify(filterVariables).replace(
      /"([^"]+)":/g,
      '$1: '
    );
    cols = JSON.stringify(cols).replace(/"([^"]+)":/g, '$1: ');
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/session?query=${encodeURIComponent(
        `{export(
            sdate: ${sdate},
            edate: ${edate},
            csv: ${payload.csv}, 
            excel: ${payload.excel}, 
            filters: ${filterVariables}, 
            cols: ${cols}, 
            type_name: "session", 
            table_name:"${clientTable}", 
            index: "all-index"
          ){
            csv,
            excel,
            success
          }}`
      )}`
    )
      .then(res => {
        commit('setExportURL', {
          csv: res.data.data.export.csv,
          excel: res.data.data.export.excel,
          loaded: true,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  exportUtilizationReport: async (
    {
      commit, state, rootGetters, rootState
    },
    payload
  ) => new Promise((resolve, reject) => {
    const attributes = state.exportData.utilization.fields;
    let cols = [];
    if (attributes[0].selected) {
      cols.push({ id: 'screen_id', title: 'Screen' });
    }
    // if (attributes[1].selected) {
    //   cols.push({ id: "ra_number", title: "Rental Agreement #" });
    // }
    // if (attributes[2].selected) {
    //   cols.push({ id: "city", title: "Originating Location" });
    // }
    // if (payload.destination_location) {
    //   cols.push({ id: "area_id", title: "Area" })
    // }
    if (attributes[1].selected) {
      cols.push({ id: 'trip_type', title: 'Rental Type' });
    }
    if (attributes[2].selected) {
      cols.push({ id: 'start_at', title: 'Rental Start Date' });
    }
    if (attributes[3].selected) {
      cols.push({ id: 'end_at', title: 'Rental End Date' });
    }
    // if (payload.rental_days) {
    //   cols.push({ id: "days", title: "Number of days" })
    // }
    // if (payload.rental_rev) {
    //   cols.push({ id: "status", title: "Active/Inactive" })
    // }

    let filterVariables = {
      type_name: 'session',
    };
    const filters = rootState.filters.filter;
    let sdate = moment('1.1.1970').format('X');
    let edate = moment().format('X');
    if (filters.area !== undefined && filters.area !== '') {
      filterVariables.area_id = filters.area;
    }
    if (
      filters.start_date !== '' &&
        filters.start_date !== undefined &&
        filters.end_date !== '' &&
        filters.end_date !== undefined
    ) {
      sdate = moment(filters.start_date).format('X');
      edate = moment(filters.end_date).format('X');
    }
    if (filters.city !== undefined && filters.city !== '') {
      filterVariables = { uuid: filters.city };
    }
    if (filters.groupName !== undefined && filters.groupName !== '') {
      filterVariables = { uuid: filters.groupName };
    }
    filterVariables = JSON.stringify(filterVariables).replace(
      /"([^"]+)":/g,
      '$1: '
    );
    cols = JSON.stringify(cols).replace(/"([^"]+)":/g, '$1: ');
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/session?query=${encodeURIComponent(
        `{export(
            sdate: ${sdate},
            edate: ${edate},
            csv: ${payload.csv}, 
            excel: ${payload.excel}, 
            filters: ${filterVariables}, 
            cols: ${cols}, 
            type_name: "session", 
            table_name:"${clientTable}", 
            index: "all-index"
          ){
            csv,
            excel,
            success
          }}`
      )}`
    )
      .then(res => {
        commit('setExportURL', {
          csv: res.data.data.export.csv,
          excel: res.data.data.export.excel,
          loaded: true,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getLaunchModeChart: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'lauchMode', value: true });
    // const clientTable = rootGetters["account/getCurrentClient"].table_name;
    // const dates = createDateParam();
    // const { variables, index } = createFilterParam(filterParams, "screen");
    graphQL({
      query: `
        query {
          getLaunchModes(sdate: ${payload.filterParams.sdate}, edate: ${payload.filterParams.edate}, filter: ${payload.filterParams.variables}){
            chartType
            showOnMobile
            type
            component
            width
            title
            data
            labels
            secondaryTitle
            options {
              colors
            }
          }
        }
      `,
    })
      .then(res => {
        res.data.data.getLaunchModes.type = 'bar-chart';
        res.data.data.getLaunchModes.chartType = 'bar';
        res.data.data.getLaunchModes.component = 'chart';
        res.data.data.getLaunchModes.data = [
          { data: res.data.data.getLaunchModes.data },
        ];
        commit('setLaunchModeChart', res.data.data.getLaunchModes);
        commit('setGraphLoadingState', {
          name: 'launchMode',
          value: false,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getRoundsPlayedChart: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'roundsPlayed', value: true });
    // const clientTable = rootGetters["account/getCurrentClient"].table_name;
    // const dates = createDateParam();
    // const { variables, index } = createFilterParam(filterParams, "screen");
    graphQL({
      query: `
        query {
          getRoundsPlayed(
            sdate: ${payload.filterParams.sdate}, 
            edate: ${payload.filterParams.edate}, 
            filter: ${payload.filterParams.variables}
          ){
            chartType
            showOnMobile
            type
            component
            width
            title
            data {
              data
            }
            labels
            secondaryTitle
            options {
              colors
            }
          }
        }
      `,
    })
      .then(res => {
        commit('setRoundsPlayedChart', res.data.data.getRoundsPlayed);
        commit('setGraphLoadingState', {
          name: 'roundsPlayed',
          value: false,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getTotalCarsChart: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'totalCars', value: true });
    graphQL({
      query: `
        query {
          getTotalCarGraph(
            sdate: ${payload.filterParams.sdate}, 
            edate: ${payload.filterParams.edate}, 
            filter: ${payload.filterParams.variables}
          ){
            data
            labels
          }
        }
      `,
    })
      .then(res => {
        const data = res.data.data.getTotalCarGraph;
        commit('setTotalCarsGraph', {
          data: [{ data: data.data, title: 'Total Active Golf Cars' }],
          labels: data.labels,
        });
        commit('setGraphLoadingState', {
          name: 'totalCars',
          value: false,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getTotalGroupsChart: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'totalGroups', value: true });
    graphQL({
      query: `
        query {
          getTotalGroups(
            sdate: ${payload.filterParams.sdate}, 
            edate: ${payload.filterParams.edate}, 
            filter: ${payload.filterParams.variables}
          ){
            data
            labels
          }
        }
      `,
    })
      .then(res => {
        const data = res.data.data.getTotalGroups;
        commit('setTotalGroupsGraph', {
          data: [{ data: data.data, title: 'Total Courses' }],
          labels: data.labels,
        });
        commit('setGraphLoadingState', {
          name: 'totalGroups',
          value: false,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getCarsByModelChart: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'carsByModel', value: true });
    graphQL({
      query: `
        query {
          getCarsByModelGraph(
            sdate: ${payload.filterParams.sdate}, 
            edate: ${payload.filterParams.edate}, 
            filter: ${payload.filterParams.variables}
          )
        }
      `,
    })
      .then(res => {
        commit('setCarsByModelGraph', [
          { data: res.data.data.getCarsByModelGraph },
        ]);
        commit('setGraphLoadingState', {
          name: 'carsByModel',
          value: false,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getGroupsByModelChart: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'groupsByModel', value: true });
    graphQL({
      query: `
        query {
          getGroupsByModel(
            sdate: ${payload.filterParams.sdate}, 
            edate: ${payload.filterParams.edate}, 
            filter: ${payload.filterParams.variables}
          )
        }
      `,
    })
      .then(res => {
        commit('setGroupsByModelGraph', [
          { data: res.data.data.getGroupsByModel },
        ]);
        commit('setGraphLoadingState', {
          name: 'groupsByModel',
          value: false,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getDynamicYardageChart: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'dynamicYardage', value: true });
    // const clientTable = rootGetters["account/getCurrentClient"].table_name;
    // const dates = createDateParam();
    // const { variables, index } = createFilterParam(filterParams, "screen");
    graphQL({
      query: `
        query {
          getDynamicYardageGraph(sdate: ${payload.filterParams.sdate}, edate: ${payload.filterParams.edate}, filter: ${payload.filterParams.variables}){
            data
            raw
            total
          }
        }
      `,
    })
      .then(res => {
        res.data.data.getDynamicYardageGraph.data = [
          Math.round(
            (res.data.data.getDynamicYardageGraph.raw /
                res.data.data.getDynamicYardageGraph.total) *
                100
          ),
        ];
        commit(
          'setDynamicYardageChart',
          res.data.data.getDynamicYardageGraph
        );
        commit('setGraphLoadingState', {
          name: 'dynamicYardage',
          value: false,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getScorecardChart: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'scorecard', value: true });
    // const clientTable = rootGetters["account/getCurrentClient"].table_name;
    // const dates = createDateParam();
    // const { variables, index } = createFilterParam(filterParams, "screen");
    graphQL({
      query: `
        query {
          getScorecardData(sdate: ${payload.filterParams.sdate}, edate: ${payload.filterParams.edate}, filter: ${payload.filterParams.variables})
        }
      `,
    })
      .then(res => {
        commit('setScorecardData', res.data.data.getScorecardData);
        commit('setGraphLoadingState', {
          name: 'scorecard',
          value: false,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getFoodAndBeverageChart: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'foodAndBeverage', value: true });
    // const clientTable = rootGetters["account/getCurrentClient"].table_name;
    // const dates = createDateParam();
    // const { variables, index } = createFilterParam(filterParams, "screen");
    graphQL({
      query: `
        query {
          getFoodAndBeverageGraph(sdate: ${payload.filterParams.sdate}, edate: ${payload.filterParams.edate}, filter: ${payload.filterParams.variables})
        }
      `,
    })
      .then(res => {
        commit(
          'setFoodAndBeverageGraph',
          res.data.data.getFoodAndBeverageGraph
        );
        commit('setGraphLoadingState', {
          name: 'foodAndBeverage',
          value: false,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getListenChart: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'listen', value: true });
    // const clientTable = rootGetters["account/getCurrentClient"].table_name;
    // const dates = createDateParam();
    // const { variables, index } = createFilterParam(filterParams, "screen");
    graphQL({
      query: `
        query {
          getListenData(sdate: ${payload.filterParams.sdate}, edate: ${payload.filterParams.edate}, filter: ${payload.filterParams.variables}){
            chartType
            showOnMobile
            type
            component
            width
            title
            data {
              data
            }
            labels
            secondaryTitle
            options {
              colors
            }
          }
        }
      `,
    })
      .then(res => {
        commit('setListenChart', res.data.data.getListenData);
        commit('setGraphLoadingState', {
          name: 'listen',
          value: false,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  getWatchChart: async ({ commit }, payload) => new Promise((resolve, reject) => {
    commit('setGraphLoadingState', { name: 'watch', value: true });
    // const clientTable = rootGetters["account/getCurrentClient"].table_name;
    // const dates = createDateParam();
    // const { variables, index } = createFilterParam(filterParams, "screen");
    graphQL({
      query: `
        query {
          getWatchData(sdate: ${payload.filterParams.sdate}, edate: ${payload.filterParams.edate}, filter: ${payload.filterParams.variables}){
            chartType
            showOnMobile
            type
            component
            width
            title
            data {
              data
            }
            labels
            secondaryTitle
            options {
              colors
            }
          }
        }
      `,
    })
      .then(res => {
        commit('setWatchChart', res.data.data.getWatchData);
        commit('setGraphLoadingState', {
          name: 'watch',
          value: false,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
};
export default actions;
